export const I18n = {
	'en': {
		name: 'Name',
		type: 'Type',
		value: 'Value',
		delete: 'Delete',
		cancel: 'Cancel',
		save: 'Save',
		yes: 'Yes',
		no: 'No',
		contactUsToAccessThis: "Contact info@hankuper.com to access this functionality"
	},
	'ru': {
		name: 'Имя',
		type: 'Тип',
		value: 'Значение',
		delete: 'Удалить',
		cancel: 'Отмена',
		save: 'Сохранить',
		yes: 'Да',
		no: 'Нет',
		contactUsToAccessThis: "Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com"
	},
	'sk': {
		name: 'Názov',
		type: 'Typ',
		value: 'Hodnota',
		delete: 'Vymazať',
		cancel: 'Zrušiť',
		save: 'Uložiť',
		yes: 'áno',
		no: 'žiadny',
		contactUsToAccessThis: "Ak chcete získať prístup k tejto funkcii, kontaktujte info@hankuper.com"
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/attributesList/index.js